import { object, string } from "yup";

export function shareRecordValidationSchema() {
    return object().shape({
        principalType: string().typeError('Tipo precisa ser selecionado').required('Tipo: Precisa ser selecionado'),
        principalId: string().typeError('Registro precisa ser selecionado').required('Registro: precisa ser selecionado'),
        permissionLevelType: string().typeError('Nível de permissão precisa ser selecionado').required('Nível de permissão: precisa ser selecionado')
    });
}

export const defaultValuesShareRecord = {
    principalType: null,
    principalId: null,
    permissionLevelType: null
};